// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart[data-v-55e868d3] {\n  width: 100%;\n  max-height: 400px;\n  font-family: Roboto, sans-serif;\n}\n", ""]);
// Exports
module.exports = exports;
